module.exports = __webpack_public_path__ + "ic-test.svg?43650cb0d7901f075c2eef1c381ef94c";